'use client';

import { useProgressing } from '@/hooks/use-progressing';
import { cn } from '@/lib/utils';
import { Gauge } from '@suyalcinkaya/gauge';
import { CustomLoadingProps } from './types';

export function GaugeLoading({ loading, className }: CustomLoadingProps) {
    const { progress } = useProgressing(loading ?? true);

    return (
        <Gauge
            className={cn('h-10 w-10', className)}
            value={progress}
            showValue
            showAnimation
        />
    );
}
